import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import ActionTriggersIndexCard from '../../ActionTriggers/ActionTriggersIndexCard';

export default function ActionTriggersPage(props) {
	// console.log('ActionTriggersPage - Props:', props);

	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.action_triggers')}
				category={I18n.t('admin.action_triggers')}
			/>
			<ActionTriggersIndexCard
				create_action_trigger_endpoint={props.create_action_trigger_endpoint}
				get_action_trigger_endpoint={props.get_action_trigger_endpoint}
				update_action_trigger_endpoint={props.update_action_trigger_endpoint}
				delete_action_trigger_endpoint={props.delete_action_trigger_endpoint}
				action_triggers_list_endpoint={props.action_triggers_list_endpoint}
				// data={[
				// 	{
				// 		id: 1,
				// 		name: 'Course Quiz Completed',
				// 		trigger_type: 'Webhook',
				// 		webhook_url: 'www.ffg.com/action/1'
				// 	},
				// 	{
				// 		id: 2,
				// 		name: 'Course Progress Completed',
				// 		trigger_type: 'Webhook',
				// 		webhook_url: 'www.ffg.com/action/2'
				// 	},
				// 	{
				// 		id: 3,
				// 		name: 'Action Trigger #3',
				// 		trigger_type: 'Webhook',
				// 		webhook_url: 'www.ffg.com/action/3'
				// 	}
				// ]}
			/>
		</div>
	);
}
